import React, { useRef, useEffect } from "react";

import { useForm } from "react-hook-form";
import { stateOfIssueOptions } from "app/utils/staticValues";

import FormGroup from "app/components/common/inputs/FormGroup";
import SelectField from "app/components/common/inputs/SelectField";
import CustomDatePicker from "app/components/common/inputs/CustomDatePicker";
import InputField from "app/components/common/inputs/InputField";
import { JointemploymentDetailsFromFour } from "app/utils/types";
import { CurrentemploymentOptions } from "app/utils/staticValues";
import AutocompleteLocations from "app/components/common/AutocompleteLocations";

const DisabledSecondEmploymentDetails: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const {
    control,
    setValue,
    clearErrors,
    formState: { errors },
    register,
    setError,
  } = useForm<JointemploymentDetailsFromFour>();

  useEffect(() => {
    if (containerRef.current) {
      const elements = containerRef.current.querySelectorAll<
        HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
      >("input, select");

      elements.forEach((el) => {
        el.disabled = true;
        el.tabIndex = -1;
      });
    }
  }, []);
  return (
    <>
      <div
        className="w-full   bg-white opacity-25 cursor-not-allowed"
        ref={containerRef}
      >
        <FormGroup>
          <InputField
            label="Occupation"
            name="yourDetails.occupation"
            control={control}
            type="text"
            required={false}
            placeholder="Designer"
            error={errors?.yourDetails?.occupation?.message}
            className="flex-1"
          />
          <CustomDatePicker
            name="yourDetails.startDate"
            control={control}
            label="Start date"
            placeholder="DD/MM/YYYY"
            rules={{ required: "Date is required" }}
            className="flex-1"
          />
        </FormGroup>
        <FormGroup>
          <SelectField
            label="Employment type"
            name="yourDetails.employmentType"
            control={control}
            options={CurrentemploymentOptions}
            placeholder="Please select employment type"
            error={errors?.yourDetails?.employmentType?.message}
            required={true}
            className="flex-1"
          />
          <InputField
            label="Employer phone number"
            name="yourDetails.employerPhoneNumber"
            control={control}
            type="number"
            required={true}
            placeholder="(201) 555-0124"
            error={errors?.yourDetails?.employerPhoneNumber?.message}
            className="flex-1"
          />
        </FormGroup>
        <FormGroup>
          <AutocompleteLocations
            FieldName="yourDetails.street"
            placeholder="1901 Thornridge Cir. Shiloh,"
            register={register}
            setValue={setValue}
            setError={setError}
            label="Address"
            required={true}
            className="flex-1"
            error={errors?.yourDetails?.street?.message}
            stateFieldName="yourDetails.state"
            postCodeFieldName="yourDetails.postCode"
            clearErrors={clearErrors}
          />
          <div className="flex-1">
            <FormGroup direction="row">
              <SelectField
                label="State"
                name="yourDetails.state"
                control={control}
                options={stateOfIssueOptions}
                placeholder="Select State"
                error={errors?.yourDetails?.state?.message}
                required={true}
                className="flex-1"
              />
              <InputField
                label="Post Code"
                name="yourDetails.postCode"
                control={control}
                type="number"
                required={true}
                placeholder="8767"
                error={errors?.yourDetails?.postCode?.message}
                className="flex-1"
              />
            </FormGroup>
          </div>
        </FormGroup>
      </div>
    </>
  );
};

export default DisabledSecondEmploymentDetails;
